// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/
import React, { Component } from "react"
import style from "./style.css"
import _ from "lodash"
import * as strings from "../../../strings"
export default class AlertBox extends Component {
  props: {
    title?: string,
    message: any,
  }

  render () {

    const title = this.props.title ?
      this.props.title :
      strings.paymentAgreements.createPaymentAgreement

    const message = _.isString( this.props.message ) ?
      (
        <div className={style.confirmDiv}>
          <h1 className={style.tableTitle}>{this.props.message}</h1>
        </div>
      ) : this.props.message

    return (
      <div className={style.insideDialog}>
        <div className={style.blueHeader}>
        </div>
        <div className={style.firstDivisor}>
          <div className={style.firstLine}>
            <span><hr className={style.divider}/></span>
          </div>
          <div className={style.secondLine}>
            <span className={style.spanText}> {title.toUpperCase()} </span>
          </div>
          <div className={style.thirdLine}>
            <span><hr className={style.divider}/></span>
          </div>
        </div>
        {message}
        <div className={style.secondDivisor}>
          <hr className={style.divider}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CreatePaymentAgreementComponents/AlertBox/index.jsx